import type { AxiosError } from 'axios';
export interface CommonRequest {
  userId: string;
  agencyCd: string[];
}

export type CommonResult = Result;

export interface ConditionItem {
  branchGroupId?: number;
  branchConditionName: string;
  specifiedCondition: (string | null)[];
}

export interface status {
  status: number;
  message?: string;
}

export const OK: status = {
  status: 200,
};
export const CREATED: status = {
  status: 201,
};
export const NO_CONTENT: status = {
  status: 204,
};
export const BAD_REQUEST: status = {
  status: 400,
  message: '無効な要求です',
};
export const UNAUTHORIZED: status = {
  status: 401,
  message: '認証が必要な要求です',
};
export const FORBIDDEN: status = {
  status: 403,
  message: '要求が拒否されました',
};
export const CONFLICT: status = {
  status: 409,
  message: '対象のデータは変更されています',
};

export const NOT_FOUND: status = {
  status: 404,
  message: '要求したリソースが存在しません',
};

export const MST_DATA_GET_FAILED: status = {
  status: 412,
  message: 'マスタデータが取得できませんでした。',
};

export const INTERNAL_SERVER_ERROR: status = {
  status: 500,
  message: 'サーバエラーが発生しています。管理者に問い合わせてください',
};

export const SERVICE_TEMPORARILY_UNAVAILABLE: status = {
  status: 503,
  message: 'サービスが利用できません',
};

// APIデバッグ用 コンソールにAPI情報を表示する
export const consoleApiLog = (url: string, type: 'FETCHING' | 'SUCCESS' | 'ERROR' = 'FETCHING', method?: string, ...params: any) => {
  switch (type) {
    case 'FETCHING':
      console.log('%c FETHING ', 'background-color: #5084d4; color: white;', method, url, ...params);
      return;
    case 'SUCCESS':
      console.log('%c SUCCESS ', 'background-color: green; color: white;', method, url, ...params);
      return;
    case 'ERROR':
      console.log('%c ERROR ', 'background-color: red; color: white;', method, url, ...params);
      return;
  }
};

export const API_RESULT_CD = {
  OK: '0000',
  DIFFARENT_SESSION: '0101',
  SESSION_NO_EXIST: '0102',
  OLD_SESSION: '0103',
  ERROR: '9999',
  CONFLICT: '409',
  NOT_FOUND: '404',
  BAD_REQUEST: '400',
};

export function createApiRequestUrl(apiName: string): string {
  return `${process.env.REACT_APP_API_URL}/${apiName}`;
}

export const MASKING = {
  DISABLE: '1',
  ABLE: '0',
};

const getErrorResponse = (errorStatusCode: number, errorMessage: string, jobDateTime: string): CommonResult => {
  return {
    jobDateTime: jobDateTime,
    resultCd: `${errorStatusCode}`,
    resultMessageDtoList: [
      {
        resultMessageCd: `${errorStatusCode}`,
        resultMessage: errorMessage,
      },
    ],
  };
};
/**
 * 400(BadRequest)をレスポンスとして受け取った場合の共通処理
 * @param jobDateTime
 * @returns
 */
export const getBadRequestResponse = (errorMessage: string, jobDateTime?: string): CommonResult => {
  const errorStatusCode = BAD_REQUEST.status;
  return getErrorResponse(errorStatusCode, errorMessage, jobDateTime || '');
};

/**
 * 403(Forbidden)をレスポンスとして受け取った場合の共通処理
 * @param jobDateTime
 * @returns
 */
export const getForbiddenResponse = (errorMessage: string, jobDateTime?: string): CommonResult => {
  const errorStatusCode = FORBIDDEN.status;
  return getErrorResponse(errorStatusCode, errorMessage, jobDateTime || '');
};

/**
 * 404(NotFound)をレスポンスとして受け取った場合の共通処理
 * @param jobDateTime
 * @returns
 */
export const getNotFoundResponse = (errorMessage: string, jobDateTime?: string): CommonResult => {
  const errorStatusCode = NOT_FOUND.status;
  return getErrorResponse(errorStatusCode, errorMessage, jobDateTime || '');
};

/**
 * 500(InternalServerError)をレスポンスとして受け取った場合の共通処理
 * @param jobDateTime
 * @returns
 */
export const getInternalServerErrorResponse = (errorMessage: string, jobDateTime?: string): CommonResult => {
  const errorStatusCode = INTERNAL_SERVER_ERROR.status;
  return getErrorResponse(errorStatusCode, errorMessage, jobDateTime || '');
};

/**
 * 409(Conflict)をレスポンスとして受け取った場合の共通処理
 * @param jobDateTime
 * @returns
 */
export const getConflictResponse = (errorMessage: string, jobDateTime?: string): CommonResult => {
  const errorStatusCode = CONFLICT.status;
  return getErrorResponse(errorStatusCode, errorMessage, jobDateTime || '');
};
/**
 * axiosのエラーなのかチェック
 * @param error - エラーオブジェクト
 * @returns axiosエラーか
 */
// axiosのバージョンが古いため、isAxiosError関数が存在しないため自作
// v0.21.1以降であれば、以下関数ではなく、isAxiosErrorが実装されているため、そちらを使用するべき
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isAxiosError = (error: any): error is AxiosError => {
  return !!error.isAxiosError;
};
